<template>
    <span class="lang">
        <span>
            <span
                :class="isUnderline('th')"
                @click="changeLangTo('th')"
                class="lang-th pointer mr-1">
                ไทย
            </span>
            |
            <span
                :class="isUnderline('en')"
                @click="changeLangTo('en')"
                class="lang-en pointer">
                EN
            </span>
        </span>
    </span>
</template>

<script>
export default {
    name: 'ChangeLang',

    props: {
        onMountedEmit: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        isUnderline (lang) {
            if (this.$vuetify.lang.current === lang) {
                return 'text-underline'
            }
            return ''
        },

        changeLangTo (lang) {
            this.$vuetify.lang.current = lang
            localStorage.setItem('lang', lang)
            this.$emit('change', lang)
        },

        getLangFromLocalStorage () {
            const currentLang = localStorage.getItem('lang')
            // has lang in local storage
            if (currentLang) {
                this.$vuetify.lang.current = currentLang
            } else {
                this.changeLangTo('th')
            }
        }
    },

    mounted () {
        this.getLangFromLocalStorage()
        if (this.onMountedEmit) {
            this.$emit('change', this.$vuetify.lang.current)
        }
    }
}
</script>

<style lang="scss" scoped>
.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    color: #131410;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}
.pointer {
    cursor: pointer;
}
.text-underline {
    text-decoration: underline;
}
</style>
